<h1 matDialogTitle>
    <ng-container *ngIf="!context.data.offline; else nointernet">
        {{ 'license_modal_activate_online_title' | translate }}
    </ng-container>
    <ng-template #nointernet>
        {{ 'license_modal_activate_online_no_internet_title' | translate }}
    </ng-template>
</h1>

<mat-dialog-content>
    <ng-container *ngIf="context.data.offline; else form">
        <p translate>license_modal_activate_online_no_internet_description</p>
    </ng-container>
    <ng-template #form>
        <form [formGroup]="formGroup">
            <mat-form-field>
                <input #installationID
                       [placeholder]="'license_modal_activate_online_installation_id' | translate"
                       [readonly]="true"
                       [value]="context.data.installationId"
                       [formControlName]="LicenseFormControl.installationId"
                       matInput
                       name="installationId"
                       required />
                <span matSuffix>
                    <button [uiClipboard]="installationID"
                            [matTooltip]="'form_action_copy' | translate"
                            (clipboardSuccess)="clipboardCopied()"
                            mat-icon-button
                            type="button">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </span>
            </mat-form-field>
            <mat-form-field>
                <input [placeholder]="'license_modal_activate_online_license_key' | translate"
                       [formControlName]="LicenseFormControl.licenseKey"
                       matInput
                       name="licenseKey"
                       required
                       data-cy="license-key-input" />
            </mat-form-field>
            <label class="mat-form-radio-label">
                {{ 'license_modal_activate_online_environment_designation' | translate}} *
            </label>
            <mat-radio-group [formControlName]="LicenseFormControl.environment"
                             name="environment"
                             required>
                <mat-radio-button value="Production"
                                  data-cy="environment-radio-production">
                    {{ 'license_modal_activate_online_production' | translate }}
                </mat-radio-button>
                <mat-radio-button value="NonProduction"
                                  data-cy="environment-radio-nonproduction">
                    {{ 'license_modal_activate_online_nonproduction' | translate }}
                </mat-radio-button>
                <mat-radio-button value="Hybrid"
                                  data-cy="environment-radio-hybrid">
                    {{ 'license_modal_activate_online_hybrid' | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </form>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button">
        {{ 'modal_action_cancel' | translate }}
    </button>
    <button [hidden]="context.data.offline"
            [disabled]="isSubmitDisabled"
            (click)="onSubmit()"
            mat-button
            type="submit"
            color="primary">
        {{ 'modal_action_activate' | translate }}
    </button>
    <button [hidden]="!context.data.offline"
            (click)="openOfflineModal()"
            mat-button
            type="button"
            color="primary"
            data-cy="activate-online-button">
        {{ 'modal_action_activate_offline' | translate }}
    </button>
</mat-dialog-actions>
